/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface McpDynamicClientRegistrationResponse
 */
export interface McpDynamicClientRegistrationResponse {
    /**
     * 
     * @type {string}
     * @memberof McpDynamicClientRegistrationResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof McpDynamicClientRegistrationResponse
     */
    clientName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof McpDynamicClientRegistrationResponse
     */
    redirectUris: Array<string>;
    /**
     * 
     * @type {Array<McpDynamicClientRegistrationResponseGrantTypesEnum>}
     * @memberof McpDynamicClientRegistrationResponse
     */
    grantTypes: Array<McpDynamicClientRegistrationResponseGrantTypesEnum>;
    /**
     * 
     * @type {Array<McpDynamicClientRegistrationResponseResponseTypesEnum>}
     * @memberof McpDynamicClientRegistrationResponse
     */
    responseTypes: Array<McpDynamicClientRegistrationResponseResponseTypesEnum>;
    /**
     * 
     * @type {McpDynamicClientRegistrationResponseTokenEndpointAuthMethodEnum}
     * @memberof McpDynamicClientRegistrationResponse
     */
    tokenEndpointAuthMethod: McpDynamicClientRegistrationResponseTokenEndpointAuthMethodEnum;
}


/**
 * @export
 */
export const McpDynamicClientRegistrationResponseGrantTypesEnum = {
    AuthorizationCode: 'authorization_code',
    RefreshToken: 'refresh_token'
} as const;
export type McpDynamicClientRegistrationResponseGrantTypesEnum = typeof McpDynamicClientRegistrationResponseGrantTypesEnum[keyof typeof McpDynamicClientRegistrationResponseGrantTypesEnum];

/**
 * @export
 */
export const McpDynamicClientRegistrationResponseResponseTypesEnum = {
    Code: 'code'
} as const;
export type McpDynamicClientRegistrationResponseResponseTypesEnum = typeof McpDynamicClientRegistrationResponseResponseTypesEnum[keyof typeof McpDynamicClientRegistrationResponseResponseTypesEnum];

/**
 * @export
 */
export const McpDynamicClientRegistrationResponseTokenEndpointAuthMethodEnum = {
    None: 'none'
} as const;
export type McpDynamicClientRegistrationResponseTokenEndpointAuthMethodEnum = typeof McpDynamicClientRegistrationResponseTokenEndpointAuthMethodEnum[keyof typeof McpDynamicClientRegistrationResponseTokenEndpointAuthMethodEnum];


/**
 * Check if a given object implements the McpDynamicClientRegistrationResponse interface.
 */
export function instanceOfMcpDynamicClientRegistrationResponse(value: object): value is McpDynamicClientRegistrationResponse {
    if ((!('clientId' in (value as Record<string, any>)) && !('client_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['clientId'] === undefined && (value as Record<string, any>)['client_id'] === undefined)) return false;
    if ((!('clientName' in (value as Record<string, any>)) && !('client_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['clientName'] === undefined && (value as Record<string, any>)['client_name'] === undefined)) return false;
    if ((!('redirectUris' in (value as Record<string, any>)) && !('redirect_uris' in (value as Record<string, any>))) || ((value as Record<string, any>)['redirectUris'] === undefined && (value as Record<string, any>)['redirect_uris'] === undefined)) return false;
    if ((!('grantTypes' in (value as Record<string, any>)) && !('grant_types' in (value as Record<string, any>))) || ((value as Record<string, any>)['grantTypes'] === undefined && (value as Record<string, any>)['grant_types'] === undefined)) return false;
    if ((!('responseTypes' in (value as Record<string, any>)) && !('response_types' in (value as Record<string, any>))) || ((value as Record<string, any>)['responseTypes'] === undefined && (value as Record<string, any>)['response_types'] === undefined)) return false;
    if ((!('tokenEndpointAuthMethod' in (value as Record<string, any>)) && !('token_endpoint_auth_method' in (value as Record<string, any>))) || ((value as Record<string, any>)['tokenEndpointAuthMethod'] === undefined && (value as Record<string, any>)['token_endpoint_auth_method'] === undefined)) return false;
    if ((value as Record<string, any>)['tokenEndpointAuthMethod'] !== 'none' && (value as Record<string, any>)['token_endpoint_auth_method'] !== 'none') return false;
    
    return true;
}

export function McpDynamicClientRegistrationResponseFromJSON(json: any): McpDynamicClientRegistrationResponse {
    return McpDynamicClientRegistrationResponseFromJSONTyped(json, false);
}

export function McpDynamicClientRegistrationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): McpDynamicClientRegistrationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['client_id'],
        'clientName': json['client_name'],
        'redirectUris': json['redirect_uris'],
        'grantTypes': json['grant_types'],
        'responseTypes': json['response_types'],
        'tokenEndpointAuthMethod': json['token_endpoint_auth_method'],
    };
}

export function McpDynamicClientRegistrationResponseToJSON(json: any): McpDynamicClientRegistrationResponse {
    return McpDynamicClientRegistrationResponseToJSONTyped(json, false);
}

export function McpDynamicClientRegistrationResponseToJSONTyped(value?: McpDynamicClientRegistrationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'client_id': value['clientId'],
        'client_name': value['clientName'],
        'redirect_uris': value['redirectUris'],
        'grant_types': value['grantTypes'],
        'response_types': value['responseTypes'],
        'token_endpoint_auth_method': value['tokenEndpointAuthMethod'],
    };
}

